<template>
  <span>
    <i
      :id="id"
      v-b-tooltip.hover.right="$utils.decodeHtml(msg || '')"
      class="fa fas fa-question-circle rs-text-secondary-light"
    />
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsInfoBlock',

  props: {
    id: {
      type: String,
      required: true,
    },

    msg: {
      type: String,
      default: '',
    },
  },
});
</script>

<style lang="scss">
@import '@/styles/_variables.scss';

</style>
